import moment from 'moment';
import TestResultsState from './TestResultsState';

class TestResultsStateByTimestamp extends TestResultsState {
  fetch({ startDate, endDate }) {
    this.newRequestID();
    this.fetchResultsTimelines({ start_time: startDate, end_time: endDate });
    this.fetchAlarmResults({
      start: moment.utc(startDate * 1000).toISOString(),
      end: moment.utc(endDate * 1000).toISOString()
    });
  }
}

export default TestResultsStateByTimestamp;
